import Footer from "../components/feature/Footer";
import Header from "../components/feature/Header";
import Stepper from "../components/feature/Stepper";
import { Box, CircularProgress, Container } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import { useAppDispatch, useAppSelector } from "../redux/store";
import { setToastData } from "../redux/slices/customerJourney";

const DefaultLayout = (props: any) => {
  const { children } = props;
  const dispatch = useAppDispatch();
  const customerJourney = useAppSelector((state) => state.customerJourney);
  const { apiloading, toastData } = customerJourney;
  return (
    <Box
      sx={{
        minHeight: "100%",
        display: "grid",
        gridTemplateRows: "1fr auto auto",
        gridTemplateColumns: "100%",
      }}
    >
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={toastData?.open}
        onClose={() => {
          dispatch(
            setToastData({
              type: toastData?.type,
              message: toastData?.message,
              open: false,
            }),
          );
        }}
        message={toastData?.message}
        autoHideDuration={3000}
        key={"top right"}
        sx={{
          "& .MuiSnackbarContent-root": {
            backgroundColor: toastData?.type === "success" ? "green" : "red",
            borderRadius: "5px",
          },
        }}
      />
      {apiloading && (
        <Box
          sx={{
            position: "fixed",
            top: "0",
            bottom: "0",
            left: "0",
            right: "0",
            background: "#0000004d",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: "999",
          }}
        >
          <CircularProgress />
        </Box>
      )}
      <Header />
      <Container component="main" maxWidth="xl" sx={{ marginTop: "70px" }}>
        <Stepper />
        {children}
      </Container>
      <Footer />
    </Box>
  );
};

export default DefaultLayout;
